export default "__VITE_ASSET__CERHQ5h$__"